import './LBCustomDropDown.style.less'

import { Checkbox, Dropdown, Input, Menu, Row } from 'antd'
import { useEffect, useRef, useState } from 'react'

import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { DownOutlined, SearchOutlined } from '@ant-design/icons'
import { isEmptyValue } from '@/utils/common'
import { getDisplayValue } from '../../util/LiveboardUtil'

interface Props {
  options: Array<any>
  name: string
  onchange: (value: any) => any
  value: any
}

function LBCustomDropDown(props: Props) {
  const selected = props.value
  const [visible, setvisible] = useState(false)
  const [searchText, setSearchText] = useState('')

  const wrapperRef = useRef(null)

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target))
        setvisible(false)
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      setvisible(false)
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [wrapperRef])

  useEffect(() => {
    if (!visible) {
      setSearchText('')
    }
  }, [visible])

  const filteredOptions = props.options.filter((field) => {
    const displayValue = getDisplayValue(field, props.name)
    return displayValue.toLowerCase().includes(searchText.toLowerCase())
  })

  return (
    <div className="custom-dropdown-container">
      <Dropdown
        placement="bottom"
        open={visible}
        overlay={
          <div ref={wrapperRef}>
            <Menu className="lb-custom-dropdown-menu">
              <Menu.Item key="search" className="search-menu-item">
                <Input
                  placeholder="Search..."
                  prefix={<SearchOutlined />}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                />
              </Menu.Item>

              {filteredOptions.length > 0 ? (
                filteredOptions.map((field) => {
                  return (
                    <Menu.Item key={field.key}>
                      <Checkbox
                        className="custom-dropdown-checkbox-full"
                        checked={selected.some(
                          (item: any) => item.key == field.key
                        )}
                        onChange={(value: CheckboxChangeEvent) => {
                          if (value.target.checked) {
                            props.onchange([...selected, field])
                          } else {
                            props.onchange(
                              selected.filter(
                                (item: any) => item.key !== field.key
                              )
                            )
                          }
                        }}
                      >
                        {getDisplayValue(field, props.name)}
                      </Checkbox>
                    </Menu.Item>
                  )
                })
              ) : (
                <Menu.Item key="no-results" disabled>
                  <div style={{ textAlign: 'center', color: '#999' }}>
                    No results found
                  </div>
                </Menu.Item>
              )}
            </Menu>
          </div>
        }
      >
        <div
          className={'custom-dropdown-liveboard'}
          onClick={() => setvisible(!visible)}
        >
          <Row align="middle">
            <p
              className="place-holder"
              style={{ color: selected.length > 0 ? '#5B5B5B' : '' }}
            >
              {props.name}
            </p>
            {!isEmptyValue(selected) && (
              <div className="length-container">
                <p className="length">{selected.length}</p>
              </div>
            )}
          </Row>
          <DownOutlined />
        </div>
      </Dropdown>
    </div>
  )
}

export default LBCustomDropDown
